/**
 * 画面を見ている人（Supabase の利用者 ID。ログインしていなければ null）が変わったか。
 *
 * 変わったら取得済みのデータ（react-query のキャッシュ）を捨てる。キャッシュのキーは
 * 利用者ごとに分けていないので、残すと前の人のワークスペース名やプロジェクトが見えてしまう。
 * previous が undefined なのは、画面を開いて最初にセッションを読んだとき。
 */
export function isViewerChanged(previous: string | null | undefined, next: string | null): boolean {
  return previous !== undefined && previous !== next
}
